import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  HookFormCheckbox,
  HookFormColorPicker,
} from "@/components_v2/FormFields/ReactHookForm/fields";
import FormFieldWrapper from "@/components_v2/Wrapper/FormFieldWrapper";
import {
  SurveyViewFormCustomizationProps,
  SurveyViewFormValues,
} from "../../types";
import Preview from "@/views/survey-views/components/Preview";

import "./styles.css";

const SurveyViewFormCustomization = ({
  form,
}: SurveyViewFormCustomizationProps) => {
  const { t } = useTranslation();

  const formData = useWatch({
    control: form.control,
  }) as SurveyViewFormValues;

  return (
    <div className="survey-view-content">
      <h2 className="header-m-medium">
        {t("surveyViews.labels.customizePdfDescription")}
      </h2>

      <div className="survey-view-customization-form">
        <div className="survey-view-customization-form-panel">
          <div className="survey-view-customization-form-panel-general">
            <h3 className="body-m-medium">{t("surveyViews.labels.general")}</h3>

            <div className="survey-view-customization-form-panel-general-fields">
              <HookFormCheckbox
                name="config.includeFrontCover"
                label={t("surveyViews.labels.includeFrontCover")}
                control={form.control}
              />

              <HookFormCheckbox
                name="config.includeTableOfContent"
                label={t("surveyViews.labels.includeTableOfContent")}
                control={form.control}
              />

              <HookFormCheckbox
                name="config.includeOrganizationSummary"
                label={t("surveyViews.labels.includeOrganizationSummary")}
                control={form.control}
              />

              <HookFormCheckbox
                name="config.includeContributors"
                label={t("surveyViews.labels.includeContributors")}
                control={form.control}
              />

              <HookFormCheckbox
                name="config.includePrmePage"
                label={t("surveyViews.labels.includePrmePage")}
                control={form.control}
              />

              <HookFormCheckbox
                name="config.includeSdgPage"
                label={t("surveyViews.labels.includeSdgPage")}
                control={form.control}
              />

              <HookFormCheckbox
                name="config.includeBackCover"
                label={t("surveyViews.labels.includeBackCover")}
                control={form.control}
              />

              <HookFormCheckbox
                name="config.includeDividers"
                label={t("surveyViews.labels.includeDividerPages")}
                control={form.control}
              />

              <HookFormCheckbox
                name="config.grayScale"
                label={t("surveyViews.labels.grayscale")}
                control={form.control}
              />
            </div>
          </div>

          <div className="survey-view-customization-form-panel-design">
            <h3 className="body-m-medium">
              {t("surveyViews.labels.frontPageDesign")}
            </h3>

            <p className="body-a-regular">
              {t("surveyViews.labels.designDescription")}
            </p>

            <FormFieldWrapper label={t("surveyViews.labels.backgroundColor")}>
              <HookFormColorPicker
                name="config.coverPageBackgroundColor"
                control={form.control}
                showText
                allowClear
              />
            </FormFieldWrapper>
          </div>
        </div>

        <div className="survey-view-customization-form-preview">
          <Preview surveyViewData={formData} />
        </div>
      </div>
    </div>
  );
};

export default SurveyViewFormCustomization;
